import './App.css';
import Home from './routes/Home';
import About from './routes/About';
import Courses from "./routes/Courses";
import Contact from './routes/Contact';
import Student from './routes/Student';
import Jee from './routes/Jee';
import Neet from './routes/Neet';
import Cet from './routes/Cet';
import Nata from './routes/Nata';
import Enquiry from './routes/Enquiry';
import { Routes, Route } from "react-router-dom"

function App() {
  return (
    <div className="App overflow-x-clip">
      <Routes>
        <Route path="/" element={ <Home/> } />
        <Route path="/about" element={ <About/> } />
        <Route path="/student" element={ <Student/> } />
        <Route path="/courses" element={ <Courses/> } />
        <Route path="/jee" element={ <Jee/> } />
        <Route path="/neet" element={ <Neet/> } />
        <Route path="/cet" element={ <Cet/> } />
        <Route path="/nata" element={ <Nata/> } />
        <Route path="/enquiry" element={ <Enquiry/> } />
        <Route path="/contact" element={ <Contact/> } />
      </Routes>
    </div>
  );
}

export default App;
